import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';
import { formatCurrency } from 'utils/NumberHelper';

const FundingReportRecord = Record({
  clientEmail: '',
  clientName: '',
  created: new Date(0),
  id: 0,
  notes: '',
  status: '',
  submission: {
    amount: 0,
    period: 0,
    companyName: '',
    companyNumber: '',
    fundingMatchesCount: 0,
  },
  team: {
    default: false,
    id: 0,
    name: '',
  },
  updated: new Date(0),
  user: {
    champion: false,
    name: null,
    team: {
      name: '',
    },
  },
  userId: 0,
});

export default class FundingReport extends FundingReportRecord {
  static deserialize(jsonObject = {}) {
    if (typeof jsonObject === 'undefined') {
      return undefined;
    }

    const mapProperties = {
      created: Hydrator.timestamp2Date,
      updated: Hydrator.timestamp2Date,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new FundingReport(hydrated);
  }

  get companyNameWithFallback() {
    return this.submission.companyName || 'N/A';
  }

  get fundingInfo() {
    return this.submission.amount
      ? `${formatCurrency(this.submission.amount)} for ${this.submission.period} months`
      : '-';
  }
}
